



































































import Vue from 'vue'
import { Component, Prop } from 'vue-property-decorator'
import CaseFoldingCard from '@/modules/Newcase/components/CaseFoldingCard.vue'
import dollarFilter from '@/utils/dollarFilter'
import { dateToDisplay, dateTimeToDisplay } from '@/utils/dateTime'
import { showErrors } from '@/utils/snack'

import DocuSignDialog from '@/modules/Policy/components/DocuSignDialog.vue'
import AppDialog from '@/components/AppDialog.vue'
import { Policy } from '@/modules/Policy/interfaces/policy'
import { getDocusignEnvelopes } from '@/modules/Envelop/gql/envelop.gql'
import { CaseReview } from '@/modules/Newcase/interfaces/case-review'

@Component({
  components: {
    CaseFoldingCard,
    AppDialog,
    DocuSignDialog
  }
})
export default class CasePolicyDocusign extends Vue {
  @Prop({ type: Object as () => Policy }) readonly policy!: Policy
  @Prop({ type: Boolean }) readonly unFolding!: boolean
  @Prop({ type: Boolean, default: true }) readonly editable!: boolean
  @Prop({ type: Object as () => CaseReview }) readonly review!: CaseReview

  envelopList: { [k: string]: any } = [];

  warning: boolean = false

  tableColumn = [
    {
      field: 'id',
      title: 'ID',
      width: 60
    },
    {
      field: 'subject',
      title: 'Envelope Name',
      slots: { default: 'subject' }
    },
    {
      field: 'client',
      title: 'Client',
      slots: { default: 'client' }
    },
    {
      field: 'clientName',
      title: 'Client Name'
    },
    {
      field: 'clientEmail',
      title: 'Email'
    },
    {
      field: 'createdAt',
      title: 'Date',
      slots: { default: 'createdAt' }
    },
    {
      field: 'createdBy.username',
      title: 'Creator'
    },
    {
      field: 'status',
      title: 'Status',
      slots: { default: 'status' }
    }
  ];

  dateToDisplay = dateToDisplay
  dateTimeToDisplay = dateTimeToDisplay
  dollarFilter = dollarFilter

  loading = false;
  docuSignDialog = {
    show: false,
    title: 'DocuSign',
    disable: false
  };

  mounted () {
    this.getEnvelopList()
  }

  // 获取信封数据
  async getEnvelopList () {
    this.loading = true
    try {
      const result = await this.$apollo.query({
        query: getDocusignEnvelopes,
        variables: {
          masterType: 'POLICY',
          masterId: +this.policy.id
        }
      })
      this.envelopList = result.data.getDocusignEnvelopes
      this.warning = this.envelopList.length === 0
      this.loading = false
    } catch (e) {
      showErrors(e.graphQLErrors)
    }
  }

  routeToDetail (item: any, routeName: string, type: string) {
    this.$router.push({
      name: routeName,
      params: {
        id: item.id + '',
        masterId: this.policy.id + '',
        masterType: 'policy',
        type
      }
    })
  }

  clickCell (data: any) {
    this.routeToDetail(
      data.row,
      'EnvelopDetail',
      data.row.status !== 'draft' ? 'detail' : 'edit'
    )
  }

  showDocuSignDialog () {
    this.docuSignDialog.show = true
  }

  hideDocuSignDialog () {
    this.docuSignDialog.show = false
  }
}
